// src/Services/bannerService.ts
import {
  collection,
  getDocs,
} from 'firebase/firestore';
import { db } from '../Firebase/Config';
import { Banner } from '../common-components/Banner-Popup/banner';

const BANNERS_COLLECTION = 'banners';

export class BannerService {
  /**
   * Fetch all banners (there should only ever be 0 or 1).
   */
  static async getBanners(): Promise<Banner[]> {
    try {
      const snapshot = await getDocs(collection(db, BANNERS_COLLECTION));
      return snapshot.docs.map((docSnap) => {
        const data = docSnap.data();
        return {
          id: docSnap.id,
          imageUrl: data.imageUrl ?? '',
          createdBy: data.createdBy,
          createdAt: data.createdAt?.toDate(),
          updatedAt: data.updatedAt?.toDate(),
        } as Banner;
      });
    } catch (error) {
      console.error('Error fetching banners:', error);
      throw error;
    }
  }
}